import { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';
import { Rnd } from 'react-rnd';
import RoadFeatureApiControls from './RoadFeatureApiControls';
import { useRouteSettings } from '../../../stores/RouteSettingsStore';
import { BruksklasseType, RoadFeatureType, RoadFeatureTypesWithBruksklasse, SourceReferenceSystem } from '../../../services/RuteplanAPI';
import { useControlsOpen, useRouteResponse, useSelectedRouteIndex } from '../../../stores/RouteStore';


const rndStyle = {
  display: "flex",
  flexDirection: 'column',
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #ddd",
  background: "#ffffffff",
  zIndex: 10900,
  borderRadius: '5px'
} as const;


export default function RoadFeatureApiView() {
    const [disableDragging, setDisableDragging] = useState(false);

    const routeSettings = useRouteSettings();
    const routeResponse = useRouteResponse();
    const selectedRouteIndex = useSelectedRouteIndex();
    const controlsOpen = useControlsOpen();

     const request: string = JSON.stringify({
        "roadFeatureTypes" : Array.from(Object.values(RoadFeatureType)),
        "outputSRS" : SourceReferenceSystem.EPSG_4326,
        nvdbReferenceLinks: routeResponse?.routes[selectedRouteIndex].nvdbReferenceLinks!
    }, null, 4);
    
    const bruksklasseRequest: string = JSON.stringify({
        "bruksklasseType": routeSettings.routeType as BruksklasseType,
        "roadFeatureTypes" : Array.from(Object.values(RoadFeatureTypesWithBruksklasse)),
        "outputSRS" : SourceReferenceSystem.EPSG_4326,
        nvdbReferenceLinks: routeResponse?.routes[selectedRouteIndex].nvdbReferenceLinks!
    }, null, 4);

    const [roadFeatureRequest, setRoadFeatureRequest] = useState<string>((
        routeSettings.routeType === 'best' ? request : bruksklasseRequest
    ));
    
    useEffect(() => {
        setRoadFeatureRequest(routeSettings.routeType === 'best' ? request : bruksklasseRequest)
    },[bruksklasseRequest, request, routeSettings.routeType]);

    const map = useMap();

    const onDrag = () => {
        map.dragging.disable();
    }

    const onDragStop = () => {
        map.dragging.enable();
    }

    const onResize = () => {
        map.dragging.disable();
    }

    const onResizeStop = () => {
        map.dragging.enable();
    }

    const onMouseEnter = () => {
        map.dragging.disable();
        map.scrollWheelZoom.disable();
        map.doubleClickZoom.disable();
    }
    
    const onMouseLeave = () => {
        map.dragging.enable();
        map.doubleClickZoom.enable();
        map.scrollWheelZoom.enable();
    }

    return(
        <>
        { controlsOpen ?  
            <Rnd
            style={rndStyle}
            default={{
                x: 350,
                y: 50,
                height: 900,
                width: 1200,
            }}
            onDrag={onDrag}
            onDragStop={onDragStop}
            onResize={onResize}
            onResizeStop={onResizeStop}   
            disableDragging={disableDragging}
            >
                <RoadFeatureApiControls 
                setDisableDragging={setDisableDragging} 
                roadFeatureRequest={roadFeatureRequest}
                setRoadFeatureRequest={setRoadFeatureRequest}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}/>
                
            </Rnd>
            : null
        }
        </>
    )    
}


